import script from "./PCShowNoResults.vue?vue&type=script&setup=true&lang=js"
export * from "./PCShowNoResults.vue?vue&type=script&setup=true&lang=js"

import "./PCShowNoResults.vue?vue&type=style&index=0&id=1af56938&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1af56938"]])

export default __exports__